import { LoginComponent } from './core/components/login/login.component';

import { HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeFr);
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '@env/environment';
import * as Sentry from '@sentry/browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from '@app/core.module';
import { ErrorComponent } from '@app/components/error/error.component';
import { MainLayoutModule } from '@layout/main-layout.module';
import { SharedModule } from '@shared/shared.module';
import { DataModule } from '@data/data.module';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AuthModule } from '@auth0/auth0-angular';

if (environment.sentryKey) {
    try {
        Sentry.init({
            dsn: environment.sentryKey,
            release: environment.release,
            environment: environment.environment
        });
    } catch (e) {
        console.error('Unable to initialize Sentry', e);
    }
}

@NgModule({
    declarations: [
        AppComponent,
        ErrorComponent,
        LoginComponent,
    ],
    imports: [
        CoreModule.forRoot(),
        BrowserModule,
        BrowserAnimationsModule,
        AuthModule.forRoot({
            domain: environment.ssoUrl.replace('https://', ''),
            clientId: environment.ssoClientId,
            authorizationParams: {
                audience: environment.ssoAudience
            }
        }),
        MainLayoutModule,
        HttpClientModule, // Should be loaded after BrowserModule,
        SharedModule,
        AppRoutingModule, // Be careful, order maters for routing modules
        DataModule,
        MatIconModule
    ],
    providers: [
        // Synapps Web is FR only
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(iconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
        iconRegistry.addSvgIconSet(
            domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg')
        );
    }
}
